import { toast } from "sonner";
import { api } from "./api";

/**
 * Show a celebratory Sonner toast for a freshly-unlocked badge.
 *
 * Default action is "Share" which downloads the server-rendered PNG card. We
 * intentionally pick the most-common interaction; the full per-tile share +
 * deeplink-copy UX lives on /app/achievements.
 *
 * `badge` shape: { type, tier, awarded_at, label }
 */
export async function notifyBadgeUnlock(badge, opts = {}) {
  if (!badge) return;
  toast.success(`Badge unlocked: ${badge.label}!`, {
    description: "View it on /app/achievements or tap Share for the card.",
    duration: 9000,
    action: {
      label: "Share",
      onClick: () => downloadBadgeCard(badge, opts),
    },
  });
}

async function downloadBadgeCard(badge, opts) {
  try {
    const payload =
      badge.type === "streak"
        ? { type: "streak", payload: { streak_days: badge.tier, longest: opts.longest || badge.tier } }
        : { type: "badge", payload: { badge_type: badge.type, tier: badge.tier, label: badge.label } };
    const { data } = await api.post("/share/card", payload, { responseType: "blob" });
    const url = URL.createObjectURL(data);
    const a = document.createElement("a");
    a.href = url;
    a.download = `daione-${badge.type}-${badge.tier}.png`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  } catch (err) {
    console.warn("Share card download failed:", err);
    toast.error("Couldn't download the share card");
  }
}
